<template>
  <inline-svg
    :src="require(`../../node_modules/@skbkontur/icons/src/${iconFolderName}/Size=${this.size}, Style=${this.type}.svg`)"
    :width="size"
    :height="size"
    fill="currentColor"
    role="presentation"
    :transformSource="transformSvg"
  ></inline-svg>
</template>

<script>
import InlineSvg from 'vue-inline-svg'

export default {
  name: 'KonturIcon',
  components: {
    InlineSvg
  },
  props: {
    name: {
      // https://ui.gitlab-pages.kontur.host/docs/#/icons
      type: String,
      required: true
    },
    size: {
      default: '16',
      type: String,
      validator(value) {
        return ['16', '20', '24', '32', '64'].includes(value)
      }
    },
    type: {
      default: 'regular',
      type: String,
      validator(value) {
        return ['light', 'regular', 'solid'].includes(value)
      }
    }
  },
  computed: {
    iconFolderName() {
      const substringToRemove = 'Icon'
      const cleanedIconName = this.name.slice(0, -(substringToRemove.length))
      const iconNameWithFixedCase = cleanedIconName.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase()

      return iconNameWithFixedCase
    }
  },
  methods: {
    transformSvg(svg) {
      const coloredElementList = [...svg.querySelectorAll('[fill]')]
      coloredElementList.forEach((path) => {
        path.setAttribute('fill', 'currentColor')
      })
      return svg
    }
  }
}
</script>
